function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.debouncedHandleSubmit = debounce((event) => {
      this.handleSubmit(event);
    }, 800).bind(this);

    this.querySelector('form').addEventListener('input', this.debouncedHandleSubmit);
    window.addEventListener('popstate', this.handleHistoryChange);
  }

  disconnectedCallback() {
    this.querySelector('form').removeEventListener('input', this.debouncedHandleSubmit);
    window.removeEventListener('popstate', this.handleHistoryChange);
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const url = `${window.location.pathname}?section_id=${document.getElementById('collection').dataset.id}&${searchParams}`;
    const filterDataUrl = (element) => element.url === url;

    FacetFiltersForm.filterData.some(filterDataUrl)
      ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
      : FacetFiltersForm.renderSectionFromFetch(url, event);

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderCollectionGrid(html);
        FacetFiltersForm.renderFilterCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderCollectionGrid(html);
    FacetFiltersForm.renderFilterCount(html);
  }

  static renderCollectionGrid(html) {
    document.getElementById('collection-grid').classList.add('opacity-0');
    document.getElementById('collection-grid').addEventListener('transitionend', () => {
      document.getElementById('collection-grid').innerHTML = new DOMParser()
        .parseFromString(html, 'text/html')
        .getElementById('collection-grid').innerHTML;
      document.getElementById('collection-grid').classList.remove('opacity-0');
    }, {once: true});
  }

  static renderFilterCount(html) {
    document.getElementById('filter-count').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('filter-count').innerHTML;
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  handleSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  handleSubmit(event) {
    event.preventDefault();

    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    const forms = [];
    sortFilterForms.forEach((form) => {
      if (form.querySelector("input:checked")?.value) {
        const formData = new FormData(form);
        const searchParams = new URLSearchParams(formData).toString();
        forms.push(searchParams);
      }
    });

    this.handleSubmitForm(forms.join('&'), event);
  }

  handleHistoryChange = (event) => {
    const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
    if (searchParams === FacetFiltersForm.searchParamsPrev) return;
    FacetFiltersForm.renderPage(searchParams, null, false, true);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
